import { render, staticRenderFns } from "./SolvedTicket.vue?vue&type=template&id=fc4242d4&scoped=true"
import script from "./SolvedTicket.vue?vue&type=script&lang=js"
export * from "./SolvedTicket.vue?vue&type=script&lang=js"
import style0 from "./SolvedTicket.vue?vue&type=style&index=0&id=fc4242d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4242d4",
  null
  
)

export default component.exports